<div [ngClass]="{'pb-5 mb-4': isMobile}" class="h-100 d-flex flex-column no-transform">
  <app-global-payment-form #globalPaymentFormComponent
                           (hasButtonDisplay)="displayButton($event)"
                           (sendInfos)="pay($event)"
                           (sendLoadingStatus)="isLoading = $event"
                           [price]="price"
                           [process]="process"
                           [promoCode]="promoCode"
                           [room]="room"
                           [service]="'ACCOMMODATION'"
                           [text]="'PROCESSES.ACCOMMODATION.PAYMENT.INFORMATION.TEXT_1'"
                           [booking]="booking"></app-global-payment-form>


  <div class="d-flex flex-row justify-content-between mt-5 align-items-start">
    <!-- promo code -->
    <app-code-promo-input (enteredPromoCodeData)="getPromoCodeInfos($event)"
                          (priceAfterPromoCode)="applyPromoCode($event)"
                          [itemPrice]="room['property_price']['reservation_fees']"
                          [propId]="booking.propId"
                          informationKey="PROCESSES.ACCOMMODATION.PAYMENT.FEES"
    ></app-code-promo-input>

    <!-- btn form -->
    <div class="fixed_on_mobile p-3 p-md-0 d-flex gap-16 hiding_for_hubspot bot">
      <div *ngIf="isMobile" class="d-flex gap-16 align-items-center">
        <lf-icon fillColor="#00C49A" height="1.5rem" name="money" width="1.5rem"></lf-icon>
        <p>{{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.REFUSED_BOOKING_MOBILE' | translate }}</p>
      </div>
      <button (click)="validate()"
        *ngIf="displayBtn"
        checkFormError
        class="btn btn-gradient-blue d-flex flex-row align-items-center">
        {{ ("PROCESSES.ACCOMMODATION.BOOK.CANDIDATE." + (isMobile ? "MOBILE" : "DESKTOP")) | translate }}
        <lf-icon *ngIf="!isLoading" class="lh-1" height="14px" name="rightChevron" width="14px"></lf-icon>
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
      </button>
    </div>


  </div>

  <div *ngIf="isMobile" class="mt-4 mt-xl-3">
    <div class="d-flex gap-16 pb-2">
      <lf-icon height="1.5rem" name="returnMoney" width="1.5rem"></lf-icon>
      <p>{{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.FEES' | translate }}</p>
    </div>
    <div class="d-flex gap-16">
      <lf-icon fillColor="#00C49A" height="1.5rem" name="money" width="1.5rem"></lf-icon>
      <p>{{ 'PROCESSES.ACCOMMODATION.LIST.CANCEL_BOOKING.REFUSED_BOOKING' | translate }}</p>
    </div>
  </div>

  <app-need-help [contact]="user.agent" *ngIf="isMobile"></app-need-help>

</div>
